import moment from "moment-timezone";

export const IST_TZ = "Asia/Kolkata";
const IST_OUTPUT_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

function isValidDate(d) {
  return d instanceof Date && !Number.isNaN(d.getTime());
}

/**
 * API returns strings like "2025-11-30T07:01:26" which should be treated as IST
 * wall-time (no timezone conversion).
 */
export function parseApiIstToMoment(value) {
  if (!value) return null;
  const m = moment.tz(value, IST_TZ);
  return m.isValid() ? m : null;
}

/**
 * For React DatePicker: create a local Date that shows the same wall-time as IST.
 * This avoids shifting the visible date for users not in IST.
 */
export function apiIstStringToPickerDate(value) {
  const m = parseApiIstToMoment(value);
  if (!m) return null;
  return new Date(
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
    m.millisecond()
  );
}

export function istNowPickerDate({ withTime = true } = {}) {
  const m = moment.tz(IST_TZ);
  return new Date(
    m.year(),
    m.month(),
    m.date(),
    withTime ? m.hour() : 0,
    withTime ? m.minute() : 0,
    withTime ? m.second() : 0,
    withTime ? m.millisecond() : 0
  );
}

/**
 * Convert a DatePicker Date (local Date) into an IST moment by treating its
 * visible components as IST wall-time.
 */
export function pickerDateToIstMoment(date) {
  if (!isValidDate(date)) return null;
  return moment.tz(
    [
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds(),
    ],
    IST_TZ
  );
}

export function formatIstOffsetFromPickerDate(date) {
  const m = pickerDateToIstMoment(date);
  return m ? m.format(IST_OUTPUT_FORMAT) : null;
}

/**
 * Ex Date payload: selected calendar day (IST) + current IST time.
 * e.g. "2026-03-12T14:05:00+05:30"
 */
export function formatExDateWithCurrentIstTime(pickerDate) {
  const mDate = pickerDateToIstMoment(pickerDate);
  if (!mDate) return null;
  const mNow = moment.tz(IST_TZ);
  const combined = mDate
    .clone()
    .hour(mNow.hour())
    .minute(mNow.minute())
    .second(mNow.second())
    .millisecond(mNow.millisecond());
  return combined.format(IST_OUTPUT_FORMAT);
}

export function formatApiIstStringWithOffset(value) {
  const m = parseApiIstToMoment(value);
  return m ? m.format(IST_OUTPUT_FORMAT) : null;
}

export function formatIstDateDisplay(value, fmt = "DD-MM-YYYY") {
  const m = parseApiIstToMoment(value);
  return m ? m.format(fmt) : "";
}

